import React, { ReactNode } from 'react';

import { cn } from '@/lib/utils';

import styles from '../booking.module.css';

type Props = {
  title?: string;
  children: ReactNode;
};

const Section = ({ title, children }: Props): JSX.Element => {
  return (
    <div className={cn('col-md-auto', styles.section)}>
      {title && <h3 className="fw-bold neu-display-4">{title}</h3>}
      <div className={styles.sectionContent}>{children}</div>
    </div>
  );
};

export default Section;
